import { Box, Stack, useTheme } from '@mui/material'
import { grey } from '@mui/material/colors'
import { makeStyles } from '@mui/styles'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import Employee from '../../../../../../api/db/Employee'
import pubsub from '../../../../../../modules/pubsub'
import { EmployeeSchema } from '../../../../../../shared/types'
import { selectUserPropsState } from '../../../../../../store/features/user'
import BodySkeleton from '../../../../common/skeletons/BodySkeleton'
import Table from '../Table'

export default function ContentBody() {

    const theme = useTheme()
    const [loading, setLoading] = useState(true)
    const [employees, setEmployees] = useState<EmployeeSchema[]>([])
    const user_id = useSelector(selectUserPropsState)?.uid

    useEffect(()=>{

        pubsub.on("employee-list:changed", fetchEmployees)

        fetchEmployees()

        return ()=>{
            pubsub.off("employee-list:changed", fetchEmployees)
        }
    // eslint-disable-next-line
    },[])

    const useStyles = makeStyles({
        content:{
            flex: 1, 
            border: `.5px solid rgba(255, 255, 255, 0.1)`,
            borderRadius: "4px", 
            minHeight: "420px", 
            backgroundColor: theme.palette.primary.main,
            padding: "1rem"
        },
        searchField:{
            backgroundColor: theme.palette.primary.dark,
            border: `.5px solid rgba(255, 255, 255, 0.1)`,
            padding: ".3rem",
            borderRadius: "3px",
            color: grey[200],
            fontWeight: "regular",
            fontSize: "14px",
            outline: "none"
        }
    })

    const classes = useStyles()

    const fetchEmployees = async ()=>{

        try {

            setLoading(true)
            const res = await Employee.getEmployees(user_id) as EmployeeSchema[]
            setEmployees(res)
            setLoading(false)
            
        } catch (error) {
            setLoading(false)
            throw error
            
        }
        
    }

    return (
        <>
            {
                loading ? (
                    <BodySkeleton />
                ):(

                    <Box className={classes.content} >

                        <Stack
                            sx={{height: "100%"}}
                            direction="column"
                            spacing={2}
                        >

                            <Table 
                                title="Employee list"
                                tableBodyData={employees}
                                tableHeadData={["Name", "Branch", "Revenue"]}
                                handleItemClick={()=>{}}
                            />

                        </Stack>

                        
                    </Box>
                    
                )
            }
        </>
    )
}
